<template>
<section v-show="!is_closed" :class="card_className">
    <div class="card-header">
        <button class="vertically-center text close-button" type="button" v-if="canClose" @click="is_closed = true">
            <i class="material-icons">close</i>
        </button>

        <button class="vertically-center text toggle-button" type="button" v-else-if="toggleable" @click="open = !open">
            <span v-show="open"><i class="material-icons">keyboard_arrow_up</i></span>
            <span v-show="!open"><i class="material-icons">keyboard_arrow_down</i></span>
        </button>

        <slot name="header">
            <div style="margin-bottom: -20px;"></div>
        </slot>
    </div>

    <div :class="body_className">
        <slot name="body"></slot>
    </div>

    <div class="card-footer">
        <slot name="footer">
            <div style="margin-top: -30px;"></div>
        </slot>
    </div>
</section>
</template>

<script>
export default {
    name: "card",

    props: ["canClose", "fixedHeight", "fullHeight", "scrollOnShow", "size", "startHidden", "state", "toggleable"],

    data () {
        return {
            body_className: {
                "card-body": true
            },
            card_className: {
                card: true,
                "full-height": this.fullHeight,
                "fixed-height": this.fixedHeight,
                small: this.size === "small",
                large: this.size === "large",
                bad: this.state && this.state.indexOf("bad") !== -1,
                good: this.state && this.state.indexOf("good") !== -1,
                warning: this.state && this.state.indexOf("warning") !== -1
            },
            initial_display_setting: null,
            is_closed: false,
            open: this.startHidden !== true
        }
    },

    watch: {
        open: function (newValue) {
            let $body = this.$el.querySelector(".card-body")

            if (this.initial_display_setting === null) {
                this.initial_display_setting = $body.style.display
            }

            $body.style.display = (newValue) ? this.initial_display_setting : "none"
        }
    },

    mounted () {
        this.open = !this.startHidden

        if (this.scrollOnShow) {
            window.scrollTo({
                behavior: "smooth",
                top: this.$el.offsetTop - 50
            })
        }
    }
}
</script>

<style>
.card {
    background: #fff;
    border: 1px solid #dcdcdc;
    display: block;
    padding: 30px;
    position: relative;
    transition: all 0.15s ease;
}

.card:hover {
    border-color: #b7b7b7;
}

.card-body {
    position: relative;
}

.card-header {
    color: #656565;
    margin-bottom: 20px;
    position: relative;
}

.card-footer {
    margin-top: 30px;
}

.card.bad {
    border-color: #ffa69d;
    color: #ff6050;
}

.card.bad:hover {
    border-color: #ff6050;
}

.card.good {
    border-color: #85dbb3;
    color: #83dbb3;
}

.card.good:hover {
    border-color: #83dbb3;
}

.card.small {
    padding: 15px 20px;
}

.card.small .card-header {
    display: none;
}

.card-small .card-footer {
    display: none;
}

/**
 * Full-heightcard
*/
.card.full-height {
    height: 100%;
    overflow: auto;
}

/**
 * Fixed-height card
*/
.card.fixed-height {
    display: flex;
    flex-direction: column;
}

.card.fixed-height .card-body {
    border: 1px solid rgba(34,36,38,.1);
    overflow-x: hidden;
    overflow-y: auto;
}

/**
 * Toggle button and Close button
*/
button.toggle-button,
button.close-button {
    color: inherit;
    font-size: 1.3em;
    position: absolute;
    outline: 0;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue